import {
  DateCalendar,
  LocalizationProvider,
  PickersDay,
  PickersDayProps,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';

import { language } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

import { checkDayIsIncluded } from '../components/utils/check-day-is-included';

export function VenueDateCalendar({
  month,
  selectedDays,
  onClickDate,
}: {
  month: Dayjs;
  selectedDays: Dayjs[];
  onClickDate: (date: Dayjs) => void;
}) {
  const CustomDay = (
    props: PickersDayProps<Dayjs> & { selectedDays?: Dayjs[] },
  ) => {
    const { selectedDays = [], day, ...other } = props;
    const isSelected = checkDayIsIncluded(selectedDays, props.day);
    return <PickersDay {...other} selected={isSelected} day={day} />;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={language}>
      <DateCalendar
        sx={{
          width: '10.5rem',
          height: '8.5rem',
          // hide header with month name
          '& .MuiPickersCalendarHeader-root': {
            display: 'none',
          },
          // hide row with days names
          '& .MuiDayCalendar-header ': {
            display: 'none',
          },
          // day button
          '& .MuiPickersDay-root': {
            width: '1.25rem',
            height: '1.25rem',
            fontSize: '0.75rem',
            fontWeight: 700,
            color: ColorsRaw.anthracite.Anthracite_5,
            '&:hover': {
              borderColor: ColorsRaw.basic.Cream,
              border: '1px solid',
            },
          },
          // day button selected
          '& .MuiPickersDay-root.Mui-selected': {
            color: ColorsRaw.basic.White,
            fontWeight: 700,
            backgroundColor: ColorsRaw.anthracite.Anthracite_4,
            '&:hover': {
              backgroundColor: ColorsRaw.anthracite.Anthracite_4,
            },
            '&.active, &:focus': {
              backgroundColor: ColorsRaw.anthracite.Anthracite_4,
            },
          },
        }}
        views={['day']}
        referenceDate={month}
        disableHighlightToday={true}
        slots={{ day: CustomDay }}
        slotProps={{
          //@ts-ignore
          day: { selectedDays },
        }}
        onChange={(date: Dayjs | null) => {
          if (date) onClickDate(date);
        }}
      />
    </LocalizationProvider>
  );
}
